import { useEffect, useState } from 'react'
import { useObstructingFeatureMarkersActions, useObstructingFeatureMarkersState } from "../../../stores/MapLayers/ObstructedRouteMarkerStore";
import trafficMessageIconResource from "../../../assets/trafficSituation2.svg"

export function ObstructingFeaturesMapLayer(){
    const [className, setClassName] = useState('mapLayerContainerInactive');

    const open = useObstructingFeatureMarkersState();
    const { toggleOpen } = useObstructingFeatureMarkersActions();

    useEffect(() => {
        if(open){
            setClassName('mapLayerContainerActive')
        }
        else{
            setClassName('mapLayerContainerInactive')
        }
    }, [open])


    return(
        <div style={{display: 'grid', marginLeft: '20px', maxHeight: '90%'}}>
            <div className={className} onClick={toggleOpen}>
                <img src={trafficMessageIconResource} alt='Hindringer kartlag' style={{width: '28px', height: '6vh', margin: 'auto'}}/>
            </div>
            <p style={{fontSize: '14px', margin: 'auto', fontWeight: 'bold'}}>Hindringer</p>
        </div>
    )
}